import { validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { gameService } from '@/services/game';
import useVuelidate from '@vuelidate/core';
import { helpers, integer, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useGameParameter() {
    const crudAction = useCrudActions();

    const model = reactive({
        phaseNames: '',
        phaseTimes: '',
        botPayPercent: 0,
        botPlayableTime: 0,
        betRange: '',
        rankBoostCharge: 0,
        rankBoostRejectLimit: 0,
        lobbyLimitTable: 0,
        canRemove: false
    });

    const validations = {
        phaseNames: { required, format: validateFormat(/^[a-zA-Z0-9,]*$/) },
        phaseTimes: {
            required,
            format: validateFormat(/^\d+(,\d+)*$/),
            validateConfirmArrayLength: helpers.withMessage(
                'Names and Times must have same number of item',
                (value: string, vm: any) => value.split(',').length == vm.phaseNames.split(',').length
            )
        },
        betRange: { required, format: validateFormat(/^(-?\d+,-?\d+,-?\d+)(;(-?\d+,-?\d+,-?\d+))*$/) },
        botPayPercent: { required, integer, minValue: minValue(0) },
        botPlayableTime: { required, integer, minValue: minValue(0) },
        rankBoostCharge: { required, integer, minValue: minValue(0) },
        rankBoostRejectLimit: { required, integer, minValue: minValue(0) },
        lobbyLimitTable: { required, integer, minValue: minValue(0) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: gameService.parameter.get,
        onSuccess: ({ data }) => Object.assign(model, data)
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                gameService.parameter.update(
                    model.phaseNames,
                    model.phaseTimes,
                    model.botPayPercent,
                    model.botPlayableTime,
                    model.betRange,
                    model.rankBoostCharge,
                    model.rankBoostRejectLimit,
                    model.lobbyLimitTable
                ),
            onSuccess: fetch
        }),
        remove: crudAction.confirmAndRemove({
            request: gameService.parameter.remove,
            onSuccess: fetch,
            onFinally: () => v$.value.$reset()
        })
    };

    return { model, v$, fetch, actions };
}
